import { getHiddenNavigationItems } from '@/helpers/navigationVisibility';
import type { MenuItem } from './types';
import { allowedToShowItem, type CurrentUser } from './allowedToShowItem';

/**
 * Apply every runtime visibility rule used by the main navigation.
 * Keeping this shared prevents alternative navigation mechanisms from exposing
 * destinations that are hidden or unavailable to the current user.
 */
export function getVisibleNavigation(
  navigation: MenuItem[],
  user: CurrentUser,
): MenuItem[] {
  const hiddenNavigationItems = getHiddenNavigationItems(user);

  const filterItems = (items: MenuItem[]): MenuItem[] =>
    items.flatMap((item) => {
      if (
        hiddenNavigationItems.includes(item.path) ||
        !allowedToShowItem(item.handle.access, user, item.path)
      ) {
        return [];
      }

      const children = item.children ? filterItems(item.children) : undefined;

      if (item.handle.type === 'collapse' && children?.length === 0) {
        return [];
      }

      return [{ ...item, children }];
    });

  return filterItems(navigation);
}
